import { useGodziDropStore } from '../../godzi/store/godziDropStore'
import { IGameInfoApi } from '../api/gameInfoApi'
import { ga4Info, GodziDropResultType, useChipSetStore, useEndGameStore, usePlayerStore, useVoucherStore } from '@slot-nx/core'
import { OngoingGameInfo } from '../api/GameInfoResponse'
import { useOngoingGameStore } from '../../game/store/ongoingGameStore'
import { GameStatus, useGameStore } from '../../game/store/GameStore'

export class GameInfoService {
  private _api: IGameInfoApi

  constructor(api: IGameInfoApi) {
    this._api = api
  }

  async getGameInfo() {
    try {
      const gameInfoResponse = await this._api.getGameInfo()
      usePlayerStore.setState({
        ...gameInfoResponse.player,
        currency: gameInfoResponse.player.currency.replace(/^k(.*)/, '$1'),
      })

      useChipSetStore.setState({
        currentIndex: gameInfoResponse.gameInfo.spinSet.findIndex(
          x => x === gameInfoResponse.gameInfo.defaultSpinValue,
        ),
        chipSet: gameInfoResponse.gameInfo.spinSet,
      })

      useGodziDropStore.setState({
        isIconOpen: gameInfoResponse.eventInfo.isIconOpen,
        promotionId: gameInfoResponse.eventInfo.promotionId,
        prizeTier: gameInfoResponse.eventInfo.prizeTier,
      })

      if (gameInfoResponse.slotVoucherSummary !== null) {
        useVoucherStore.setState({
          tempSlotVoucher: gameInfoResponse.slotVoucherSummary,
        })
      }

      const ongoingGame = gameInfoResponse.gameInfo.ongoingGame
      if (ongoingGame != null) {
        restoreOngoingGame(ongoingGame)
      }

      ga4Info.setPlayerId(gameInfoResponse.player.playerId)
    }
    catch (e) {
      console.error(e)
    }
  }
}

/**
 * 重新整理後恢復未結算的注單：結果存進 ongoingGameResult（不進 gameResult，
 * 避免 server 原始格式被當成播放格式讀取），進入 init game 時自動觸發 start spin 重播。
 */
function restoreOngoingGame(ongoingGame: OngoingGameInfo) {
  // 未結算單：重播動畫播完後由 endGameService 結算
  useEndGameStore.setState({ refNo: ongoingGame.refNo, isSettled: false })
  useOngoingGameStore.getState().setOngoingGameResult(ongoingGame.gameResult)
  const chipSet = useChipSetStore.getState().chipSet
  const stakeIndex = chipSet.findIndex(chip => chip === ongoingGame.playStake)
  if (stakeIndex !== -1) {
    useChipSetStore.setState({ currentIndex: stakeIndex })
  }
  // WinningService.updateWinLabel 比較 totalPayout 跟 lastPayStake，重播時不會經過
  // PlaceOrderService.placeOrder()（它才是平常設定 lastPayStake 的地方），沒補這行會讓
  // lastPayStake 停在預設值 0，導致重播時任何 payout 都被誤判成超過 stake 而顯示「Win」而非「Return」
  useGameStore.setState({ lastPayStake: ongoingGame.playStake })
  if (ongoingGame.godziDropResult.type !== GodziDropResultType.None) {
    useGodziDropStore.setState({
      effectiveStake: ongoingGame.godziDropResult.effectiveStake,
      type: ongoingGame.godziDropResult.type,
      prize: ongoingGame.godziDropResult.prize,
      payout: ongoingGame.godziDropResult.payout,
      freeSpinCount: ongoingGame.godziDropResult.freeSpinCount,
      gameResultList: ongoingGame.godziDropResult.gameResultList,
    })
  }
  if (ongoingGame.isVoucher) {
    restoreOngoingVoucher()
  }
}

/**
 * 斷線重連時若未結算注單是 voucher 局：比照 initVoucher 還原啟用中的 voucher 狀態，
 * 讓 replay 期間 isVoucher() 判斷與 totalPayout 累加維持正常，但不彈出選擇 popup。
 */
function restoreOngoingVoucher() {
  const slotVoucher = useVoucherStore.getState().tempSlotVoucher
  if (slotVoucher == null) return
  useGameStore.setState({ gameStatus: GameStatus.Voucher })
  useVoucherStore.setState({
    currentVoucherId: slotVoucher.voucherId,
    fixedStake: slotVoucher.fixedStake,
    totalPayout: slotVoucher.winAmount,
    totalSpin: slotVoucher.freeSpin,
    remainSpin: slotVoucher.netFreeSpin,
    expireDate: slotVoucher.expireDate,
  })
}
